module.exports = __webpack_public_path__ + "static/img/logo.bd6e9b25.png";